<!--
 * @Author:
 * @Description: OpcHda
-->
<template>
  <el-card class="h-full">
    <el-row class="mb-10px">
      <el-col :span="24" class="flex">
        <el-date-picker
          type="datetimerange"
          size="small"
          class="mr-10px"
          value-format="yyyy-MM-dd HH:mm:ss"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          range-separator="-"
          v-model="searchFrom.time"
          :disabledDate="disabledDate"
          clearable
        ></el-date-picker>
        <el-button size="small" type="primary" @click="searchList">搜索</el-button>
        <el-button size="small" @click="reset">重置</el-button>
        <el-button size="small" type="primary" :loading="dataAddLoading" @click="dataAdd"
          >数据补采</el-button
        >
        <el-button size="small" type="primary" :loading="dataAddLoading" @click="toViewProgress"
          >补采进度</el-button
        >
        <el-button size="small" type="primary" @click="backTo">返回</el-button>
      </el-col>
    </el-row>
    <el-table
      border
      stripe
      class="mt-20px"
      height="calc(100% - 94px)"
      header-align="left"
      :data="opchdaDataList"
      v-loading="tableLoading"
    >
      <el-table-column type="index" width="50" :label="`${$t('serialNumber')}`">
        <template slot-scope="scope">
          <div>
            {{ scope.$index + 1 + (page.pageNo - 1) * page.pageSize }}
          </div>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip label="设备编码(kks)" prop="kks"></el-table-column>
      <el-table-column show-overflow-tooltip label="设备名称(opc da item)" prop="pointName">
      </el-table-column>
      <el-table-column show-overflow-tooltip label="测点类型" prop="pointType">
        <template slot-scope="scope">
          <span>{{ scope.row.pointType === 0 ? '开关量（整型）' : '模拟量(浮点型)' }}</span>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip label="测点描述" prop="pointDescription">
      </el-table-column>
      <el-table-column show-overflow-tooltip label="单位" prop="unit"> </el-table-column>
      <el-table-column show-overflow-tooltip label="机组" prop="machineSet"> </el-table-column>
    </el-table>
    <div class="flex justify-end">
      <el-pagination
        class="my-20px"
        :current-page.sync="page.pageNo"
        :page-size.sync="page.pageSize"
        :page-sizes="[15, 30, 50, 100]"
        :background="true"
        layout="sizes, total, prev, pager, next, jumper"
        :total="page.pageTotal"
        @size-change="searchList"
        @current-change="getTableData"
      />
    </div>
    <!-- 补采进度弹框 -->
    <progessDialog
      v-if="addProgessdialogVisible"
      @closeDialog="closeDialog"
      :progressKey="this.progressKey"
      :dialogVisible="addProgessdialogVisible"
    ></progessDialog>
  </el-card>
</template>
<script type="text/babel">
import configManagementService from '@/services/configManagementService'
import progessDialog from './components/progessDialog'

export default {
  name: 'opc-hda',
  components: { progessDialog },
  data() {
    return {
      protocolData: {
        sourceName: '',
        sourceTypeName: '',
        remark: '',
      },
      opchdaDataList: [],

      tableLoading: false,
      dialogVisible: false,
      addProgessdialogVisible: false,
      collectionProgress: 0,
      searchFrom: {
        time: '',
      },
      page: {
        pageNo: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      dataAddLoading: false,
      progressKey: '',
    }
  },
  computed: {
    currentDataSource() {
      return this.$route.params ? this.$route.params.data : ''
    },
  },
  watch: {
    currentDataSource: {
      handler(val) {
        if (val) {
          this.searchList()
        }
      },
      immediate: true,
    },
  },
  created() {},
  methods: {
    // 返回
    backTo() {
      this.$router.go(-1)
    },
    // 重置
    reset() {
      this.searchFrom.time = ''
      this.page = this.$options.data().page
      this.searchList()
    },
    searchList() {
      this.page.pageNo = 1
      this.getTableData()
    },
    // 获取表格数据
    async getTableData() {
      if (!this.searchFrom.time) {
        this.searchFrom.time = ''
      }
      this.tableLoading = true
      console.log(this.searchFrom.time, 'this.searchFrom.time')
      const res = await configManagementService.getListHistory({
        startTime: this.searchFrom.time[0],
        endTime: this.searchFrom.time[1],
        dataSourceConfigId: this.currentDataSource.id,
        maxResultCount: this.page.pageSize,
        skipCount: this.page.pageSize * (this.page.pageNo - 1),
      })
      this.tableLoading = false
      if (res && res.code === 0) {
        this.opchdaDataList = res.data
        this.page.pageTotal = res.totalCount
      }
    },
    // 数据补采
    async dataAdd() {
      if (!this.searchFrom.time) {
        this.$message.warning('请选择补采时间')
        return
      }
      this.dataAddLoading = true
      const res = await configManagementService.collectHistoryData({
        start: this.searchFrom.time[0],
        end: this.searchFrom.time[1],
      })
      this.dataAddLoading = false
      if (res && res.code === 0) {
        this.progressKey = res.data
        this.$message.success('数据补采成功')
        this.searchList()
      }
    },
    // 补采进度
    toViewProgress() {
      this.addProgessdialogVisible = true
    },
    closeDialog() {
      this.addProgessdialogVisible = false
    },
    disabledDate(time) {
      return time.getTime() > new Date() - 8.64e7
    },
  },
}
</script>
<style lang="scss" scoped>

@media (min-width: 1420px) {
  .table-container {
    height: calc(100% - 100px);
  }
}

@media (max-width: 1420px) {
  .table-container {
    height: calc(100% - 135px);
  }
}

@media (max-width: 1080px) {
  .table-container {
    height: calc(100% - 180px);
  }
}
@media (max-width: 670px) {
  .table-container {
    height: calc(100% - 225px);
  }
}
::v-deep .el-card__body {
  height: 100%;
}

</style>
